export default __webpack_public_path__ + "static/media/Type-G.4e28ea4b.jpg";